function waitForWidget(callback) {
  const interval = setInterval(() => {
    const widget = document.querySelector(".reeview-app-widget");
    if (widget && widget.shadowRoot) {
      clearInterval(interval);
      callback(widget.shadowRoot);
    }
  }, 200);
}

waitForWidget((shadowRoot) => {
  const observer = new MutationObserver(() => {
    const addBtns = shadowRoot.querySelectorAll('.vw--icon-button');

    const expandBtns = shadowRoot.querySelectorAll('.vw-expand-button');
    if (expandBtns.length > 0) {
      expandBtns.forEach((btn) => {
        btn.remove();
      });
    }

    if (addBtns.length === 0) return;

    addBtns.forEach((btn, index) => {
      if (btn.dataset.customHandled) return;

      const btnParent = btn.closest('.vw--inline-shoppable-product');
      
      setTimeout(() => {
        const itemContainer = btnParent;
        itemContainer.removeAttribute('style');
        itemContainer.querySelectorAll('*').forEach(el => {
          el.removeAttribute('style');
        });
        const productImg = itemContainer.querySelector('img').src;
        const productUrl = itemContainer.querySelector('a').href.split('.com')[1];

        // Generate a random ID
        const randomId = Math.floor(Math.random() * 100000);

        // Create the replacement HTML
        const wrapper = document.createElement('div');
        wrapper.id = `shopify-section-${randomId}`;
        wrapper.className = 'shopify-section';
        wrapper.innerHTML = `
            <modal-opener class="modal-open aa" data-modal="#QuickAdd-${randomId}">
              <button id="quick-add-${randomId}-submit" type="submit" name="add" class="quick-add__submit" data-product-url="${productUrl}">
                <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="12.9023" y="0.5" width="25" height="0.806452" transform="rotate(90 12.9023 0.5)" fill="black"></rect>
                  <rect y="12.5967" width="25" height="0.806452" fill="black"></rect>
                </svg>
                <div class="loading__spinner hidden">
                  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                    <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                  </svg>
                </div>
              </button>
            </modal-opener>
            <quick-add-modal id="QuickAdd-${randomId}" class="quick-add-modal">
                <div
                  role="dialog"
                  aria-modal="true"
                  class="quick-add-modal__content global-settings-popup"
                  tabindex="-1"
                >
                  <button
                    id="ModalClose-${randomId}"
                    type="button"
                    class="quick-add-modal__toggle"
                    aria-label="Close"
                  >
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0431 11.7926L0.750453 0.5L0.043346 1.20711L11.336 12.4997L0.0429688 23.7927L0.750075 24.4998L12.0431 13.2068L23.2932 24.457L24.0003 23.7499L12.7502 12.4997L24 1.24994L23.2929 0.542832L12.0431 11.7926Z" fill="black"/>
                    </svg>
                  </button>
                  <div id="QuickAddInfo-${randomId}" class="quick-add-modal__content-info scrollbar-hidden"></div>
                </div>
              </quick-add-modal>
        `.trim();

        // Mark original so it's not reprocessed
        btn.dataset.customHandled = "true";

        // Replace original with new content
        btn.parentElement.replaceWith(wrapper);

      }, 100);

    });
  });

  observer.observe(shadowRoot, {
    childList: true,
    subtree: true,
  });
});